import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { BaseButton } from '../button';
import { Variables } from '../variables';

export const dayPickerBaseStyles = css`
    .rdp-root {
        --rdp-accent-color: ${Variables.Colors.b300};
        --rdp-accent-background-color: ${Variables.Colors.b300_l96};
        --rdp-day-height: 36px;
        --rdp-day-width: 36px;
        --rdp-day_button-height: 34px;
        --rdp-day_button-width: 34px;
        --rdp-day_button-border-radius: 50%;
        --rdp-today-color: ${Variables.Colors.sunset500};
        --rdp-outside-opacity: 0.5;
        --rdp-selected-border: 2px solid ${Variables.Colors.b300};

        font-family: ${Variables.Fonts.calibre};
        padding: 8px;
    }

    .rdp-month_caption {
        padding: 4px 8px;
        font-size: 16px;
        font-weight: 500;
        color: ${Variables.Colors.n70};
    }

    .rdp-dropdowns {
        gap: 8px;
    }

    .rdp-dropdown_root {
        font-size: 14px;
        font-weight: 500;
        color: ${Variables.Colors.n70};
    }

    .rdp-dropdown {
        cursor: pointer;

        &:focus-visible ~ .rdp-caption_label {
            outline: 2px solid ${Variables.Colors.b300};
            outline-offset: 2px;
            border-radius: 4px;
        }
    }

    .rdp-caption_label {
        padding: 4px 4px 4px 8px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;

        &:hover {
            background-color: ${Variables.Colors.n5};
        }
    }

    .rdp-chevron {
        fill: ${Variables.Colors.n50};
    }

    .rdp-button_next,
    .rdp-button_previous {
        border-radius: 4px;

        &:hover {
            background-color: ${Variables.Colors.n5};
        }
    }

    .rdp-weekday {
        font-size: 12px;
        font-weight: 500;
        color: ${Variables.Colors.n50};
    }

    .rdp-day {
        font-size: 14px;
        font-weight: 500;
        color: ${Variables.Colors.n70};
    }

    .rdp-today:not(.rdp-outside) {
        color: ${Variables.Colors.sunset500};
    }

    .rdp-outside {
        color: ${Variables.Colors.n30};
    }

    .rdp-disabled {
        color: ${Variables.Colors.n30};
    }

    .rdp-selected .rdp-day_button {
        background-color: ${Variables.Colors.b300};
        color: ${Variables.Colors.white};
        border-color: ${Variables.Colors.b300};
    }

    .rdp-month_grid {
        margin: 0 8px 8px 8px;
    }
`;

export const DatePicker = styled.span`
    display: inline-block;
    
    /* Override icon size for datepicker only */
    & button[type="button"] svg {
        width: 20px !important;
        height: 20px !important;
    }
`;

export const DatePickerWrapper = styled.div`
    ${dayPickerBaseStyles}
`;

export const Navbar = styled.div``;

export const RangeNavbar = styled.div`
    border-bottom: ${Variables.Borders.regular};
    padding: 12px 24px;
    display: flex;
    flex-direction: column;
`;

export const RangeItem = styled.div`
    display: flex;
    align-items: center;

    &:last-of-type {
        margin-top: 8px;
    }
`;

export const RangeLabel = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: ${Variables.Colors.n30};
    width: 32px;
    text-align: right;
`;

const RangeValue = styled.div`
    margin-left: 8px;
    width: 144px;
    height: 24px;
    line-height: 24px;
    border-radius: 12px;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
`;

export const RangeValueFrom = styled(RangeValue)`
    background-color: #ffe7db;
`;

export const RangeValueTo = styled(RangeValue)`
    background-color: #dbe5fb;
`;

export const Controls = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
`;

export const Title = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: ${Variables.Colors.n70};
`;

export const ButtonsWrapper = styled.div``;

export const IconButton = styled(BaseButton)`
    min-width: auto;
    padding: 0;
    fill: ${Variables.Colors.n30};

    &:hover {
        fill: ${Variables.Colors.n70};
    }
`;
